<template>
  <div class="container" v-show="showNotVip" @click.self="hideToast">
    <div class="content">
      <div class="song-name">{{showNotVipTitle}}</div>
      <div class="load-bar">
        <div class="load-bar-inner" data-loading="0" id='progress'> <span id="counter"></span> </div>
      </div>
      <div class="loading">歌曲加载中...</div>
      <div class="button" @click='jump'>
        <img src="./static/open_vip.png" alt="">
      </div>
      <div class="tip" @click='jump'>专属VIP特权，低至每月3元>></div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'notVipToast',
  computed: {
    ...mapState({
      showNotVip: (state) => state.showNotVip,
      showNotVipTitle: (state) => state.showNotVipTitle,
    }),
  },
  data() {
    return {
      percent1: 30,
      percent2: 60,
      toastShow: false,
      timer: null,
    };
  },
  mounted() {
    const progress = document.getElementById('progress');
    const that = this;
    progress.addEventListener('webkitAnimationEnd', () => {
      that.$store.commit('SHOW_NOTVIP', false);
      window.clearTimeout(this.timer);
    }, false);
  },
  methods: {
    jump() {
      this.$router.push('/thunder/openvip?fromType=notVipToast');
      this.$store.commit('SHOW_NOTVIP', false);
      this.$store.commit('SHOW_NOTVIP_TIMER', false);
    },
    hideToast() {
      this.$store.commit('SHOW_NOTVIP', false);
      this.$store.commit('SHOW_NOTVIP_TIMER', false);
    },
  },
};
</script>
<style lang="scss" scoped>

@keyframes loader {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
@-moz-keyframes loader {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
@-webkit-keyframes loader {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
@-o-keyframes loader {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

@keyframes loader {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
.container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: $z_index_important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content {
  width: 500px;
  height: 712px;
  background: url("./static/not_vip.png") no-repeat;
  background-size: 100% auto;
  text-align: center;
  .song-name {
    min-height: 48px;
    font-size: 34px;
    margin-top: 345px;
    color: #F0CF96;
    font-weight: bold;
  }
}
.progress {
  width: 335px;
  height: 16px;
  margin: 40px auto 0;
  .weui-progress,
  .weui-progress__bar {
    height: 16px;
  }
}
.load-bar {
  width: 400px;
  height: 10px;
  margin: 40px auto 0;
  border-radius: 9px;
  background: #000;
  position: relative;
}
.load-bar-inner {
  height: 99%;
  width: 0%;
  border-radius: inherit;
  position: relative;
  background: #F0CF96;
  animation: loader 2s linear 1;
  -moz-animation: loader 2s linear 1;
  -webkit-animation: loader 2s linear 1;
  -o-animation: loader 2s linear 1;
  animation-delay:2s;
  -webkit-animation-delay:2s;
  -moz-animation-delay: 2s;
  -o-animation-delay: 2s;
}
.loading {
  font-size: 26px;
  margin: 16px 0 55px;
  color: #A98F64;
}
.button {
  width: 360px;
  margin: 0 auto;
  img {
    width: 100%;
  }
}
.tip {
  margin-top: 14px;
  font-size: 26px;
  color: #D86532;
}
</style>
